@if (!list) {
  <div>
    <app-empty-state
      [isLoading]="true"
      [message]="' Loading '"
    ></app-empty-state>
  </div>
}
@if (list && list.length === 0) {
  <div class="empty-message">
    <div class="text">- No pending connection requests -</div>
  </div>
}
@if (list && list.length !== 0) {
  <div>
    @for (request of list; track request) {
      <div
        class="celo-hoverable"
        data-testid="connection-request"
        [attr.data-user-id]="request.userId"
      >
        <div mat-ripple>
          <div class="item">
            <div
              class="icon celo-cursor-pointer"
              (click)="openProfile(request.userId)"
            >
              <app-avatar
                [name]="request.firstName + ' ' + request.lastName"
                [userId]="request.userId"
                [width]="50"
                [height]="50"
                [hasImage]="!!request.profilePic"
                [showBadge]="true"
                [badgeSize]="18"
                [workspaces]="request.workplaces"
                [identityVerificationStatus]="
                  request.identityVerificationStatus
                "
                [showTooltip]="false"
                [user]="request"
              ></app-avatar>
            </div>
            <div class="content">
              <span class="text"
                ><span
                  class="name celo-cursor-pointer celo-hoverable"
                  (click)="openProfile(request.userId)"
                  >{{ request.firstName }} {{ request.lastName }}
                </span>
                @if (!request.accepted) {
                  <span>would like to connect with you.</span>
                }
                @if (request.accepted) {
                  <span class="appear_2">is now a connection.</span>
                }
              </span>
              @if (
                !request.accepted &&
                request.connection &&
                request.connection.state === "Pending" &&
                request.connection.createdBy !== userAccount.userId
              ) {
                <div class="buttons" [ngClass]="{ 'float-right': floatRight }">
                  <div>
                    <button
                      mat-button
                      class="celo-primary-button celo-button-sm"
                      (click)="
                        acceptConnection(request.connection);
                        $event.stopPropagation()
                      "
                    >
                      <span>ACCEPT</span>
                    </button>
                  </div>
                  <div>
                    <button
                      mat-button
                      class="celo-secondary-button celo-button-sm"
                      (click)="
                        deleteConnection(request); $event.stopPropagation()
                      "
                    >
                      <span>DECLINE</span>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
